import React, {useState, useCallback, useContext, useEffect} from 'react';
import { useForm } from 'react-hook-form';
import { useMutation } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup, ButtonContainer } from 'app/src/elements/buttons';
import { View, Pressable, Text } from 'react-native';
import { CREATE_EXPENSE_LINE, SELECTS } from './queries';
import { useLazyQuery } from '@apollo/client';
import { formatAssetNameForSelect } from '../../../utils/formatAssetName';
import Autocomplete from '../../Autocomplete';
import AuthContext from '../../../contexts/AuthContext';
import {
  ExpenseLineRow,
  ExpenseLineCellNoBorder,
  ExpenseLineCellExpandedNoBorder,
  ExpenseLineFunctionsCellNoBorder
} from '.';
import { LinkSpace } from '../../../elements';

const NewExpenseLine = ({knownAssetId, updateExpenseLinesList,
  setShowAddExpenseLine, expense, refetch
}) => {
  const auth = useContext(AuthContext);
  const [submitting, setSubmitting] = useState();
  const [assetId, setAssetId] = useState(knownAssetId);
  const [assets, setAssets] = useState();
  const [selectOptions, setSelectOptions] = useState([])
  const [createExpenseLine] = useMutation(CREATE_EXPENSE_LINE, {
    onCompleted: (response) => {
      refetch();
      updateExpenseLinesList(response.createExpenseLine.expenseLine, true)
      setShowAddExpenseLine(false);
    }
  });

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    createExpenseLine({ variables: input });
  });

  // const [ loadSelectOptions, { loading: loading, data: data } ] =
  //   useLazyQuery(SELECTS, {
  //     onCompleted: () => setSelectOptions(data?.saleAssetOptions)
  //   }
  // );

  const { control, handleSubmit, register, setValue, getValues, watch,
    formState: { errors } } = useForm({
    defaultValues: {
      expenseId: expense?.id,
      assetId: assetId || '',
      // saleAssetId: '',
      amount: '',
      description: '',
    }
  });

  // const watchAssetId = watch('assetId');

  // useEffect(() => {
  //   if(!selectOptions) {
  //     loadSelectOptions({variables: {assetId: getValues('assetId') || assetId}})
  //   }
  // }, [watchAssetId])

  return (
    <ExpenseLineRow>
      <ExpenseLineCellExpandedNoBorder>
        { !assetId &&
          <Autocomplete
            label={'Asset'}
            placeHolder={''}
            resource={'Asset'}
            options={assets}
            setValue={setValue}
            name='assetId'
          />
        }
      </ExpenseLineCellExpandedNoBorder>
      {/* <ExpenseLineCellExpandedNoBorder>
        {getValues('assetId') ?
          <Input.Picker
            label="Sale:"
            name="saleAssetId"
            control={control}
            errors={errors}
            options={
              selectOptions?.map(option => {
                return {value: option.id, label: option.lotNumber}
              })
            }
          /> :
          <Autocomplete
            label={'Sale'}
            placeHolder={''}
            resource={'SaleAsset'}
            setValue={setValue}
            name='saleAssetId'
            {...register("saleAssetId", {
              required: "Required",
            })}
          />
        }
      </ExpenseLineCellExpandedNoBorder> */}
      <ExpenseLineCellNoBorder>
        <Input.Currency
          label="Amount:"
          name="amount"
          control={control}
          errors={errors}
          id="amount"
          {...register("amount", {
            required: "Amount is required",
            maxLength: { value: 8, message: 'Must be less than $1,000,000' },
            validate: {
              matchPattern: (v) =>
                /\d{1,10}(\.{1}\d{1,2}){0,1}?$/.test(v) ||
                "Please use number only without commas",
            },
          })}
        />
      </ExpenseLineCellNoBorder>
      <ExpenseLineCellNoBorder>
        <Input.Text
          label="Description:"
          name="description"
          control={control}
          errors={errors}
        />
      </ExpenseLineCellNoBorder>
      <ExpenseLineFunctionsCellNoBorder>
        <Pressable
          onPress={handleSubmit(onSubmit)}
        >
          <Text>save</Text>
        </Pressable>
        <LinkSpace />
        <Pressable
          onPress={() => setShowAddExpenseLine(false)}
        >
          <Text>cancel</Text>
        </Pressable>
      </ExpenseLineFunctionsCellNoBorder>
    </ExpenseLineRow>
  )
}

export default NewExpenseLine;
